var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StreamChatClear',{on:{"on-close":_vm.onClose,"on-clear-chat":_vm.onClearChat}})
}
var staticRenderFns = []

export { render, staticRenderFns }